<!--实时报表-->
<template>
    <div v-show="isShow" :style="domStyle">
        <div class="realHeader" ref="realColor" id="realReport" >
            <Table stripe size="small" :disabled-hover="true" :height="tableHeight" :columns="columns" :data="realFormData" ref="realTable"></Table>
            <Page :total="dataCount" :current="currentPage" :page-size="pageSize" size="small" class="paging" @on-change="changepage"></Page>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
        <Icon type="ios-settings" size="20" class="setting" @click="addPoint"/>
    </div>
</template>
<style scoped>
    .paging{
        float:right;
        margin-top:5px;
        white-space: nowrap;
        display:flex;
    }
    .setting{
        position: absolute;
        top:0;
        right:0;
        cursor:pointer;
    }
    .realHeader{
        --fontColor : #515a6e;
        --oddColor  : #fff;
        --evenColor : #f8f8f9;
        --thColor :  #f8f8f9;
        --bgColor : #f8f8f9;
        --borderColor : #000;
    }
    #realReport>>>.ivu-table{
        color : var(--fontColor);
    }
    #realReport>>>.ivu-table td{
        background-color : var(--evenColor);
    }
    #realReport>>>.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td{
        background-color : var(--oddColor);
    }
    #realReport>>>.ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td{
        background-color : var(--oddColor);
    }
    #realReport>>>.ivu-table th{
        background-color: var(--thColor);
    }
    #realReport>>>.ivu-table{
        background-color:var(--bgColor);
    }
    #realReport>>>.ivu-page-next{
        background-color:var(--bgColor);
    }
    #realReport>>>.ivu-page-prev{
        background-color:var(--bgColor);
    }
    #realReport>>>.ivu-page-item{
        background-color:var(--bgColor);
    }
    #realReport>>>.ivu-table:after{
        background-color:transparent
    }    
    #realReport>>>.ivu-table:before{
        background-color:transparent
    }    
    /* 边框为其进行隐藏 */
    #realReport>>>.ivu-table-wrapper{
        border:none;
    }
    #realReport>>>.ivu-table th{
        border:none;
    } 
    #realReport>>>.ivu-table td{
        border-color: var(--borderColor);
    }
</style>
<script>
import Vue from "vue";
import Print from 'print-js';
import { locale, Page } from "view-design";
import cn from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
Vue.component("Page", Page);
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.changeLange();
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px",
            backgroundColor:this.backgroundColor
        };
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5",
            zIndex: 1
        };
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        this.updateHeader();
    },
    mounted(){
        this.func();
    },
    watch:{
        'realFormData':{
            handler(val,oldVal){
                var n = 0;
                this.isTransparent ? n = 0.2 : n = 1; 
                if(this.$refs.realColor){
                    this.$refs.realColor.style.setProperty("--oddColor",this.realFormData.length != 0 ? this.colorRgba(this.oddColor,n) : this.colorRgba("#f8f8f9",n));
                };
            },
            deep : true
        }
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            columns:[],             // 报表表头
            realFormData : [],      // 报表数据存储
            interval : 2000,        // 初始查询数据间隔
            tableHeight : 0,
            pageSize : 5,
            currentPage : 1 ,          // 当前页数
            dataCount:0,        // 总条数
            tableColWidth: 200,  //表格列宽
            // 版本号
            version: "10.0.3.1"
        }
    },
    methods:{
        changeLange() {
            if (this.$store.state.system.$.languageName == "ch") {
                locale(cn);
            } else {
                locale(en);
            }
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(time){
            if(this.isEnable) return;
            var newTime = new Date().getTime();
            if(newTime - this.lastTime < this.interval){
                return;
            }else{
                this.lastTime = newTime;
                this.updateRealData();
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.realWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
            this.tableHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 29;
            this.updateHeader();
            this.isShow = false;
            this.$nextTick(() => {
                this.isShow = true;
                this.changeLange();
            });
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：value 周期刷新频率  
            作用：修改周期刷新的频率 默认为 1 秒
        */
        UpDataTimeStep(value){
            this.interval = value * 1000;
        },
        /*
            参数：propertyName 点属性名称  
            作用：添加点属性名称
        */
        AddProperty(propertyName){
            if(this.propertys != null){
                if(this.propertys.indexOf(propertyName) == -1){
                    this.propertys.push(propertyName);
                }
            }else{
                this.propertys = [propertyName];
            }
            this.updateHeader();
            this.updateRealData();
        },
        /*
            参数：tagName 点名称  
            作用：添加点名称
        */
        AddTag(tagName){
            if(this.dbVar != null){
               if(this.dbVar.indexOf(tagName) == -1){
                   this.dbVar.push(tagName.replace(".PV",""));
               }
            }else{
                this.dbVar = [tagName];
            }
            this.updateHeader();
            this.updateRealData();
        },
        /*
            参数：tagName 点名称
            作用：删除点
        */
        DeleteTag(tagName){
            if(this.dbVar != null){
                for(var i = 0; i < this.dbVar.length; i++){
                    if(this.dbVar[i] === tagName.replace(".PV","")){
                        this.dbVar.splice(i,1);
                    }
                }
            };
            this.currentPage = 1;
            this.updateHeader();
            this.updateRealData();
        },
        /*
            参数：propertyName 点属性名称
            作用：删除点属性
        */
        DeleteProperty(propertyName){
            if(this.propertys != null){
                for(var i = 0 ; i < this.propertys.length; i++){
                    if(this.propertys[i] === propertyName){
                        this.propertys.splice(i,1);
                        this.updateHeader();
                        this.updateRealData();
                    }
                }
            }
        },
        /*
            参数：无  
            作用：横纵表的切换
        */
        UpDataFormat(){
            this.arrayType = !this.arrayType;
            this.currentPage = 1;
            this.updateHeader();
            this.updateRealData();
        },
        /*
            参数：无
            作用：打印表单
        */
        Print(){
             if(this.nav()){
                this.$Message.warning("手机以及ipad不支持表单打印!")
            }else{
                this.$Spin.show();
                var columnName = [];
                if(this.arrayType){
                    for(var k in this.jsonData[0]){
                        columnName.push(k);
                    }
                }else{
                    this.columns.forEach((item) => {
                        columnName.push(item.key);
                    })
                    columnName = Array.from(new Set(columnName));
                }
                Print({
                    printable : this.realFormData,
                    properties : columnName,
                    type: 'json',
                        onLoadingEnd: () => {
                        this.$Spin.hide();
                    }
                })
            }
        },
        /*----------------------------------------------脚本在上--------------------------------------------- */
        /*----------------------------------------------方法在下--------------------------------------------- */
        /*
            参数：无
            作用：控制class样式绑定为变量
        */
        func(){
            // 改变表单字体颜色为用户配置
            var n = 0;
            this.isTransparent ? n = 0.2 : n = 1; 
            this.$refs.realColor.style.setProperty("--oddColor",this.realFormData.length != 0 ? this.colorRgba(this.oddColor,n) : this.colorRgba("#f8f8f9",n));
            this.$refs.realColor.style.setProperty("--fontColor",this.fontColor);

            this.$refs.realColor.style.setProperty("--evenColor",this.colorRgba(this.evenColor,n));

            this.$refs.realColor.style.setProperty("--thColor",this.colorRgba(this.tableBackgroundColor,n));

            this.$refs.realColor.style.setProperty("--bgColor",this.isTransparent ? "transparent" : "#f8f8f9");
            this.$refs.realColor.style.setProperty("--borderColor",this.borderColor);
        },
        /*
            参数：无
            作用：获取点列表从而对表单数据进行添加
        */
        addPoint(){
            this.showTagSelectDialog().then((req) =>{
                if(req){
                    // 通过选中的点进行数据添加
                    var arr =  req.name.split(".");
                    // 删除最后一个
                    arr.pop();
                    var name = arr.join(".");
                    this.AddTag(name);
                }
            });
        },
        /*
            参数：无
            作用：获取点列表数据
        */
        async showTagSelectDialog(){
            var tagName;
            await this.fvSystemApi.selectTagsShow("Test.测试1.tag1.PV",true,true,true).then(function(name){
                tagName = name;
            })
            return tagName;
        },
        /*
            参数：无
            作用：表头的变化
        */
        updateHeader(){
            this.columns = [];
            // 去重后的点属性
            this.columns.push(
                {
                    title : this.fvSystemApi.getResource("点名") || "点名",
                    key   : "NAME",
                    tooltip : true,
                    align : "center",
                    width : this.tableColWidth
                }
            )
            if(this.arrayType){
                if(this.dbVar != null){
                    for(var i = 0 ; i < this.dbVar.length ; i++){
                        var obj = {};

                        obj.title = this.fvSystemApi.getResource(this.dbVar[i].split("$").join("")) || this.dbVar[i].split("$").join("");
                        obj.key   = this.dbVar[i].split("$").join("");
                        obj.tooltip = true;
                        obj.align = "center";
                        obj.width = this.tableColWidth;
                        this.columns.push(obj);
                    }
                }
            }else{
                if(this.propertys != null){
                    for(var i = 0 ; i < this.propertys.length ; i ++){
                        var obj = {};
                        obj.title = this.fvSystemApi.getResource(this.propertys[i]) || this.propertys[i];
                        obj.key   = this.propertys[i];
                        obj.tooltip = true;
                        obj.align = "center";
                        obj.width = this.tableColWidth;
                        this.columns.push(obj);
                    }
                }
            }

            // 计算字符宽度
            let canvas = document.createElement('canvas');
            canvas.style.positon = "ablsolute";
            let ctx = canvas.getContext('2d');
            let domWidth = parseInt(this.domStyle.width);
            // 计算数据长度值
            let countNum = 0;
            this.columns.map((item) => {
                let maxWidth = this.getCharSizeByCanvas(item.title.toString(), canvas, ctx);
                // 计算累计值
                countNum += maxWidth + 50;
                // 给表头赋值宽度
                item.width = maxWidth + 50;
            });
            // 如果数据累加的值没有容器本身宽，那么就自适应，如果超过了，那么就按照原来的方式显示
            if(countNum < domWidth) {
                let difference = (domWidth - countNum) / this.columns.length;
                this.columns.map((item, index) => {
                    item.width +=  difference;
                });
            };
        },
        // 计算文字长度
        getCharSizeByCanvas(char, canvas, ctx, style = {}) {
            let {
                fontSize = 14,
                fontFamily = "Arial"
            } = style
            document.body.appendChild(canvas)
            ctx.font = `${fontSize}px ${fontFamily}`
            document.body.removeChild(canvas)
            let text = ctx.measureText(char) // TextMetrics object
            ctx.fillText(char, 50, 50)
            return text.width
        },
        /*
            参数：无
            作用：判断用户表单横纵展示不同的数据获取
        */
        updateRealData(){
            var temporaryData = [];
            if(this.dbVar != null && this.dbVar.length != 0){
                this.dbVar.forEach((item) => {
                    if(item != ""){
                        var data = this.fvSystemApi.getReal(item.split("$").join("")+".PV");
                        if(typeof data == "object"){
                            if(data.NAME){
                                data = this.copy(item.split("$").join("")+".PV");
                                data.NAME=data.NAME.split("$").join("");
                                temporaryData.push(data);
                            }else{
                                
                            }
                            
                        }
                    }
                })
            }
            if(temporaryData.indexOf(undefined) == -1){
                temporaryData.forEach((item) => {
                    item.TIME = new Date(item.TIME).format("yyyy/MM/dd hh:mm:ss");
                    if(item.PV == -9999){
                        item.PV = "- -"
                    }else if(typeof(item.PV) == "boolean"){
                        if(item.PV){
                            item.PV = 1;
                        }else{
                            item.PV = 0;
                        }
                    }
                })
                 if(this.arrayType){
                     
                    //横向
                    this.processingData(temporaryData)
                }else{
                    //纵向
                    this.disposeData(temporaryData);
                }
            }else{
                //this.updateRealData();
            }
        },
        /*
            参数：data 需要修正的数据
            作用：将PV的数据保留3位小数
        */
        disposeData(data){
            data.forEach((item) => {
                if(typeof(item.PV) == "number"){
                    item.PV = item.PV.toFixed(3);
                }
            })
            this.onChange(data);
        },
        /*
            参数：index 当前页数
            作用：切换分页
        */  
        changepage(index){
            if(this.temporaryData != undefined){
                this.currentPage = index;
                this.dataCount = this.temporaryData.length;
                var _start = (index - 1) * this.pageSize;
                var _end   = index * this.pageSize;
                var data = this.temporaryData.slice(_start,_end);
                this.updateFormData(data);
            }
        },
        /*
            参数：data 需要刷新到表单的数据
            作用：将数据渲染到表单
        */
        updateFormData(data){
            this.realFormData = data;
            // 将表单数据转换为打印数据
            this.jsonData = JSON.parse(JSON.stringify(data));
            this.disposePrintData(this.jsonData);
        },
        /*
            参数：data 需要修正的数据
            作用：将数据从纵向格式改为横向格式
        */
        processingData(data){
            var temporaryData = [];
            for (let i = 0; i < this.propertys.length; i++) {
                let obj = {};
                obj["NAME"] = this.propertys[i];
                for (let j = 0; j < data.length; j++) {
                    if(data[j][this.propertys[i]]){
                        if(obj["NAME"] == "PV"){
                            if(typeof data[j][this.propertys[i]] == "number"){
                                obj[data[j]["NAME"]] = data[j][this.propertys[i]].toFixed(3);
                            }else{
                                obj[data[j]["NAME"]] = data[j][this.propertys[i]];
                            };  
                        }else{
                            obj[data[j]["NAME"]] = data[j][this.propertys[i]];
                        };
                    };
                }
                temporaryData.push(obj);
            };
            this.arrangementData(temporaryData);
        },
        /*
            参数：data 需要修正的数据
            作用：将数组进行合并同时对PV数据进行保留3位小数的操作
        */
        arrangementData(data){
            this.onChange(data);
        },
        /*
            参数：data 表单刷新的数据
            作用：计算表单当前页能展示多少数据 同时跳转到当前默认页数的表单
        */
        onChange(data){
            this.temporaryData = data;
            var page = Math.floor((this.tableHeight - 31.89)/40);
            this.pageSize = page > 1 ? page : 1;
            this.changepage(this.currentPage);
        },
        /*
            参数： 无
            作用：关闭窗口是注销注册点
        */
        onClose(){
            // 注销注册点
            this.fvSystemApi.endReal();
        },
        /*
            参数： data 点名
            作用：深拷贝实时数据防止刷新至表上的数据不听变换
        */
        copy(data){
            return JSON.parse(JSON.stringify(this.fvSystemApi.getReal(data)));
        },
        /*
            参数： data 表单数据
            作用：将表单数据转换为json形式运用于打印功能
        */
        disposePrintData(data){
            if(this.arrayType){
                // 横
                data.forEach((item) => {
                    for(var k in item){
                        var key = k.replace(/\./g,"-");
                        item[key] = item[k];
                        if(k.indexOf(".") != -1){
                            delete item[k]
                        }
                        if(k == "NAME"){
                            item["点名"] = item[k];
                            delete item[k];
                        }
                    }
                })
            }else{
                // 纵
                data.forEach((item) => {
                    for(var k in item){
                        if(k.indexOf("_") != -1 || k == "TIME"){
                            delete item[k]
                        }
                    }
                })
            }
        },
        /*
            参数：无
            作用：判断是否支持导出的设备
        */  
        nav(){
            var ua = navigator.userAgent;
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
                isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/),
                isMobile = isIphone || isAndroid;
            if(isIphone || isAndroid || isMobile){
                return true;
            }else{
                return false;
            }
        },
        /*
            参数：str 十六位制颜色 n 透明度
            作用：将十六位制的颜色转为rgba
        */
        colorRgba (str,n){
            if(!str) return;
            //十六进制颜色值的正则表达式
            var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            var sColor = str.toLowerCase();
            //十六进制颜色转换为RGB格式  
            if(sColor && reg.test(sColor)){  
                if(sColor.length === 4){
                    var sColorNew = "#";  
                    for(var i=1; i<4; i+=1){  //例如：#eee,#fff等
                        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));     
                    }  
                    sColor = sColorNew;  
                }  
                //处理六位颜色值  
                var sColorChange = [];  
                for(var i=1; i<7; i+=2){  
                    sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));    
                }
                return "rgba(" + sColorChange.join(",") + ","+n+")"; 
            }else{  
                return sColor;    
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvRealReport/fvRealReport.vue